export default {
    name: 'reviewDistribution',

    props: {
        starDistribution: {},
        numReviews: Number
    },

    computed: {
        fiveStarPercentage(){
            return (this.starDistribution["5"] / this.numReviews) * 100
        },
        fourStarPercentage(){
            return (this.starDistribution["4"] / this.numReviews) * 100
        },
        threeStarPercentage(){
            return (this.starDistribution["3"] / this.numReviews) * 100
        },
        twoStarPercentage(){
            return (this.starDistribution["2"] / this.numReviews) * 100
        },
        oneStarPercentage(){
            return (this.starDistribution["1"] / this.numReviews) * 100
        },
    },
};
